import React, { useState } from "react"

// reactstrap components
import {
    Button,
    FormGroup,
    Input,
    Row,
    Col,
    Card,
    Media
} from "reactstrap";

// core components
import Select from "react-select";
import styled from "styled-components"
import Form from "reactstrap/lib/Form";

const SearchDiv = styled.div`

    .fill {
        min-width: 100%;
    }
`

// fields are the fields to search by, it could either be an array or a function that returns an array
// setSearchResults stores the results
// searchList is the list being searched in
export default function SearchForm({ fields, setSearchResults, searchList }) {

    const [searchBy, setSearchBy] = useState("");
    const [searchString, setSearchString] = useState("")

    const search = () => {
        try {
            if (typeof (searchString) === "string") {
                const regEx = new RegExp(searchString, "gi")
                setSearchResults(searchList.filter((obj) => obj && searchBy && obj[searchBy]?.match(regEx)))
            }
            // This else if is for when a user searches based on isDisplayed/ any boolean
            else if (typeof (searchString) === "boolean") {
                setSearchResults(searchList.filter((obj) => obj[searchBy] === searchString))
            }
        }
        catch {
        }
    }

    const clear = () => {
        setSearchResults([])
        setSearchBy("")
        setSearchString("")
    }

    return (
        <Card className="section-dark-blue">
            <Media style={{ padding: "2%" }}>
                <Form className="form" style={{ minWidth: "100%", minHeight: "100%" }}>
                    <Media body>
                        <SearchDiv>
                            <Row>
                                <Col lg="6" md="6" sm="12">
                                    {
                                        typeof (searchList[0][searchBy]) !== "boolean" ?
                                            <FormGroup>
                                                <Input
                                                    placeholder="SEARCH"
                                                    type="text"
                                                    className="fill no-border"
                                                    value={searchString}
                                                    onChange={(e) => setSearchString(e.target.value)}
                                                />
                                            </FormGroup>
                                            :
                                            <FormGroup>
                                                <Select
                                                    className="react-select react-select-default border-input"
                                                    name="boolOption"
                                                    value={setSearchString}
                                                    onChange={(value) => setSearchString(value.value)}
                                                    options={[{ value: true, label: "TRUE" }, { value: false, label: "FALSE" }]}
                                                    placeholder={searchString.toString().toUpperCase() || searchBy + "?"}
                                                />
                                            </FormGroup>
                                    }
                                </Col>
                                <Col lg="6" md="6" sm="12" >
                                    <FormGroup style={{ zIndex: 1 }}>
                                        <Select
                                            className="react-select react-select-default fill no-border"
                                            name="searchBy"
                                            value={searchBy}
                                            onChange={(value) => setSearchBy(value.value)}
                                            options={fields() || fields}
                                            placeholder={searchBy || `SEARCH BY`}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="6" md="6" sm="6" xs="6">
                                    <FormGroup>
                                        <Button
                                            className="btn-magnify btn-round mr-1 fill"
                                            color="info"
                                            onClick={() => search()}
                                        >
                                            <i className="nc-icon nc-zoom-split mr-1" />
                                        </Button>
                                    </FormGroup>
                                </Col>
                                <Col lg="6" md="6" sm="6" xs="6">
                                    <FormGroup>
                                        <Button
                                            className="btn-round mr-1 fill"
                                            color="danger"
                                            onClick={() => clear()}
                                        >
                                            X
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </SearchDiv>
                    </Media>
                </Form>
            </Media>
        </Card >
    )
}